
const [
    _loadListenerList_symbol,
    _createNativeInstance,
    _fireLoadSuccess,
    _createProxyAble,
    _createMethodProxy,
    _doCreateProxy,
    _createNativeInstancePromise
] = [
    Symbol('_loadListenerList'),
    Symbol('_createNativeInstance'),
    Symbol('_fireLoadSuccess'),
    Symbol('_createProxyAble'),
    Symbol('_createMethodProxy'),
    Symbol('_doCreateProxy'),
    Symbol('_createNativeInstancePromise'),
]

/**
 * 原生组件基类
 *
 * @Overview(概述)：
 *      所有native提供的可供h5端调用的组件，在h5端都有对应的组件对象与之映射，
 *      且都需要继承该 NativeComponent 类。
 *      NativeComponent类提供了基础的支持确保业务代码在调用前端映射组件的任何方法时，
 *      native端已经创建好了对应的组件供我们使用。
 *
 *
 * @Attention：
 *      NativeComponent类的所有子类凡是以native开头命名的方法，均会被包装一层promise代理，
 *      使之被调用时，会等到native端已经创建好具体的组件并返回了组件id时，该方法才被实际调用并返回调用结果
 *
 *
 * @time：2019/12/08
 *
 */
export default class NativeComponent {

    /**
     * 原生组件基类构造方法
     * @param action 创建原生组件对应的api
     * @param params 创建原生组件api所需的参数
     */
    constructor (action, params={}) {

        if(!action){
            throw new Error('required action')
            return false
        }

        /**
         * 组件id， 映射原生组件的id
         * @type {Number, String}
         */
        this.id = undefined

        /**
         * 组件所在广告位id
         * @type {Number, String}
         */
        this.unitId = undefined

        /**
         * 原生组件加载成功的监听队列
         * @type {Array}
         * @private
         */
        this[_loadListenerList_symbol] = []

        /*this[_createNativeInstancePromise] = this[_createNativeInstance](action, params)
        this[_createNativeInstancePromise].then((id, unitId)=>{
            this.id = id
            this.unitId = unitId
            this[fireLoadSuccess]()
        })*/

        this[_createNativeInstancePromise] = new Promise(resolve => {
            setTimeout(()=>{
                this.id = 1001
                this.unitId = 2002
                console.log('=========>native component create success')
                this[_fireLoadSuccess]()
                resolve()
            },2e3)
        })

    }

    /**
     * 通知native创建对应的原生组件
     * @param action 创建原生组件对应的api
     * @param params 创建原生组件api所需的参数
     * @returns {Promise<any>}
     * @private
     */
    [_createNativeInstance] (action, params){
        return new Promise((resolve, reject) => {
            action(params).then((res)=> {
                const {code, data={}} = res
                if(code === 0) {
                    const nativeInstance = data.cmpt
                    if(nativeInstance) {
                        const { id, unitid } = nativeInstance
                        resolve(id, unitid)
                    }else {
                        reject(new Error('创建失败'))
                    }
                }else {
                    reject(new Error('创建失败'))
                }

            })
        })
    }

    [_fireLoadSuccess](){
        this[_loadListenerList_symbol].forEach(fn=>{
            fn()
        })
        this[_loadListenerList_symbol].length = 0
    }

    /**
     * 当native端创建组件成功后触发
     * @param listener
     */
    onCreateSuccess(listener){
        if(listener && typeof listener === 'function'){
            if(!this.id){
                this[_loadListenerList_symbol].push(listener)
            }else {
                listener.call(this)
            }
        }else {
            console.warn('注册组件创建监听，参数类型错误')
        }
    }

    /**
     * 装饰器 ，用于标示组件的实际能力由native提供
     * @param target
     * @param name
     * @param descriptor
     */
    static nativeComponentAbility(target, name, descriptor){
        let targetFunction = descriptor.value
        if('function' === typeof targetFunction){
            descriptor.value = function(...arg){
                const component = this
                return component[_createNativeInstancePromise].then(()=>{
                    return targetFunction(...arg)
                })
            }
        } else {
            console.warn('nativeComponentAbility装饰器只能装饰在类的实例方法上')
        }
    }
}
